import { render, staticRenderFns } from "./SubpasosReceta.vue?vue&type=template&id=5a4f6041&scoped=true&"
import script from "./SubpasosReceta.vue?vue&type=script&lang=js&"
export * from "./SubpasosReceta.vue?vue&type=script&lang=js&"
import style0 from "./SubpasosReceta.vue?vue&type=style&index=0&id=5a4f6041&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4f6041",
  null
  
)

export default component.exports